import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class ChannelPrivateError extends CodedError {
  static get errorName() {
    return errorCodes.channelPrivateError.code;
  }

  constructor(message: string = errorCodes.channelPrivateError.message) {
    super(message);
    this.code = errorCodes.channelPrivateError.code;
    this.message = `${message} ${errorCodes.channelPrivateError.code}`;
    this.name = errorCodes.channelPrivateError.name;
  }
}
